import { HttpClient } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { API_HOST } from "environments/environment"

@Injectable({
    providedIn: 'root'
})
export class MarkoutsApiService {

    constructor(private http: HttpClient) { }

    public create(data:any) {
        return this.http.post(API_HOST + 'markouts', data)
    }

    public update(id, data:any) {
        return this.http.put(API_HOST + `markouts/${id}`, data)
    }

    public delete(id:string) {
        return this.http.delete(API_HOST + `markouts/${id}`)
    }

    public get(params) {
        return this.http.get(API_HOST + `markouts?` + new URLSearchParams(params).toString())
    }
    
    public getById(id:string) {
        return this.http.get(API_HOST + `markouts/${id}`)
    }
    
    public toggleArchive(id:string) {
        return this.http.patch(API_HOST + `markouts/${id}/archive`, null)
    }
}